// TS1108: scripts run as a function body, so a top-level return is fine
export const TopLevelReturn = 1108
